import { h as __h } from "preact";
/** @import { relayResponse } from "~/backend/validate.js"; */
import { ApiError, authedApiRequest } from "~/lib/api.js";
import { alert } from "~/util/alert.js";
import html from "~/util/html.js";
import Query from "~/util/query.js";
import { confirmModal } from "~/component/ConfirmModal.js";

/**
 * @param {{ orgId: string }} props
 * @param {relayResponse} relay
 */
export const deleteRelay = async ({
  orgId
}, relay) => {
  const res = await confirmModal({
    title: `Delete '${relay.name}'?`,
    action: "Delete",
    body: __h("p", {}, "This relay will be permanently removed.")
  });
  if (!res) return;
  try {
    await authedApiRequest("DELETE", `/v2/orgs/${orgId}/relays/${relay.id}`);
    Query.invalidate([`/v2/orgs/${orgId}/relays`], [`/v2/orgs/${orgId}/relays/${relay.id}`], [`/v2/orgs/${orgId}/locations`], [`/v2/orgs/${orgId}/locations/${relay.location_id}`]);
    return true;
  } catch (err) {
    alert(ApiError.from(err).message, {
      type: "error"
    });
    return;
  }
};